import { Button, Card, Flex, Spin } from "antd";
import "./BankDashboardPage.scss";
import DonutProgressChart from "../../Reuseable/DonutProgressChart/DonutProgressChart";
import reliance from "../../assets/Images/bankLogo/reliance.svg";
import citi from "../../assets/Images/bankLogo/reliance.svg";
import sbi from "../../assets/Images/bankLogo/citi.svg";
import pnb from "../../assets/Images/bankLogo/PNB.svg";
import boa from "../../assets/Images/bankLogo/BOA.svg";
import usbank from "../../assets/Images/bankLogo/USBank.svg";
import EllipsisMenu from "../../Reuseable/EllipsisMenu/EllipsisMenu";
import { ReactComponent as Eye } from "../../assets/Images/eye.svg";
import { ReactComponent as Download } from "../../assets/Images/download.svg";
import { useNavigate } from "react-router-dom";
import { fetchBankDashboard } from "../../store/portfolioSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency, formatWithCommas, getUserType } from "../../assets/helpers";
import { getPortfolioLink } from "../../assets/api/portfolio";
import { fetchTelecallerBankDashboard } from "../../store/telecaller/telecallerDashboard";

const logos = {
  "HDFC RARC": reliance,
  "Citi Bank": citi,
  "State Bank of India": sbi,
  "Punjab National Bank": pnb,
  "Bank Of America": boa,
  "US Bank": usbank,
};

const BankDashboardPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, user } = useSelector(state => state.auth);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const { bankDashboard, bankDashboard_loading } = useSelector(
    (state) => state?.portfolio
  );
  const { tele_bank_dashboard_loading, tele_bank_dashboard } = useSelector(state => state.telecallerDashboard)
  const { format } = useSelector(state => state.priceFormat)
  console.log(tele_bank_dashboard, 'dkljfkldjfkdjf');
  useEffect(() => {
    dispatch(fetchBankDashboard());
    dispatch(fetchTelecallerBankDashboard())
  }, [dispatch]);

  const getBankDashboard = (type) => {
    switch (type) {
      case "telecaller":
        return {
          data: tele_bank_dashboard,
          loading: tele_bank_dashboard_loading
        } ?? null;
      case "agency":
        return {
          data: bankDashboard,
          loading: bankDashboard_loading
        } ?? null;
      default:
        return null;
    }
  }

  const getBankDetails = (e, bank_id) => {

    navigate(`/bank-dashboard/bank-details/${bank_id}`);
  };
  const getUrl = () => {
    switch (getUserType(user)) {
      case "telecaller":
        return "telecaller/data-export";
      case "agency":
        return "portfolio/bank-data-export";
      default:
        return null;
    }
  }
  const url = getUrl();

  const downloadPortfolio = async (e, id) => {
    // e.preventDefault(); 
    try {
      setDownloadLoading(id);
      const res = await getPortfolioLink(token, id ,url);

      if (res?.status === 200) {
        const url = res?.data?.data?.download_url;

        if (url) {

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "portfolio.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setDownloadLoading(null)
        }
      }
    } catch (error) {
      console.error("Error downloading portfolio:", error);
      setDownloadLoading(null)
    }
  };


  const normalizedBanks = (bankDashboard_loading || tele_bank_dashboard_loading)
    ? Array(4).fill(0)
    : Array.isArray(getBankDashboard(getUserType(user))?.data)
      ? getBankDashboard(getUserType(user))?.data?.map((bank) => ({
        ...bank,
        totalODPOS: bank.total_odpos ?? "N/A",
        resolvedCases: Number(bank?.resolved_cases) || "N/A",
        unresolvedCases: Number(bank?.unresolved_cases) || "N/A",
        progressPercent: bank?.progress_percent,
        logo: logos[bank.name] || "N/A",
      }))
      : [];

  return (
    <Flex className="dashboard-page-main">
      <p className="heading">Bank Dashboard</p>
      <Flex className="card-container-wrapper">
        {Array.isArray(normalizedBanks) &&
          normalizedBanks?.map((bank, index) =>
            getBankDashboard(getUserType(user))?.loading ? (
              <Card className="loaderCard" loading={true} />
            ) : (
              <Flex className="card-container" key={index}>
                <Flex className="bank-name-container">
                  <Flex
                    className="bank-name"
                    onClick={(e) => getBankDetails(e, bank?.id)}
                  >

                    <p className="heading">{bank?.name}</p>
                  </Flex>
                  {downloadLoading === bank?.id ? (
                    <Button type="text" loading={true} />
                  ) : (
                    <EllipsisMenu
                      options={[
                        {
                          icon: <Eye />,
                          label: "Show Report",
                          onClick: (e) => getBankDetails(e, bank?.id),
                          highlight: true,
                        },
                        {
                          icon: <Download />,
                          label: "Download Data",
                          onClick: (e) => downloadPortfolio(e, bank?.id),
                        },
                      ]}
                    />
                  )}



                </Flex>

                <Flex className="bank-info-container">
                  <Flex className="bank-info-content">
                    <Flex className="bank-info-total">
                      <p className="total">Total ODPOS</p>
                      <p className="balance">{formatCurrency(bank?.total_odpos, format)}</p>
                    </Flex>

                    <Flex className="bank-info-stats">
                      <Flex className="info-stats-wrap">
                        <div className="color-div green"></div>
                        <p>Resolved Cases -</p>
                        <p className="cases-value">{formatWithCommas(bank?.resolvedCases)}</p>
                      </Flex>

                      <Flex className="info-stats-wrap">
                        <div className="color-div orange"></div>
                        <p>Unresolved Cases -</p>
                        <p className="cases-value">{formatWithCommas(bank?.unresolvedCases)}</p>
                      </Flex>
                    </Flex>
                  </Flex>

                  <Flex className="bank-info-graph">
                    <DonutProgressChart
                      data={[
                        { name: "Resolved Cases", value: bank?.resolvedCases },
                        {
                          name: "Unresolved Cases",
                          value: bank?.unresolvedCases,
                        },
                      ]}
                      colors={["#4CAF50", "#F5A623"]}
                      centerLabel="Progress"
                      percentage={bank?.progressPercent}
                      percentagePrecision={2}
                    />
                  </Flex>
                </Flex>
              </Flex>
            )
          )}
      </Flex>
    </Flex>
  );
};

export default BankDashboardPage;
